import {getAddress} from 'backend/common.jsw'
import {session} from 'wix-storage';
import wixLocation from 'wix-location';


$w.onReady(function () {
    if(session.getItem("isBackFromUserConfirm") == "true"){
        $w("#email").value = session.getItem("email");
        $w("#firstName").value = session.getItem("firstName");
        $w("#lastName").value = session.getItem("lastName");
        $w("#firstNameKana").value = session.getItem("firstNameKana");
        $w("#lastNameKana").value = session.getItem("lastNameKana");
        $w("#phone").value = session.getItem("phone");
        $w("#country").value = session.getItem("country");
        $w("#postCode").value = session.getItem("postCode");
        $w("#prefectures").value = session.getItem("prefectures");
        $w("#municipalities").value = session.getItem("municipalities");
        $w("#address").value = session.getItem("address");
        // $w("#address2").text = userInfo.address2;
        $w("#birthday").value = session.getItem("birthday") ? new Date(session.getItem("birthday")) : null;
        $w("#sex").value = session.getItem("sex");
        $w("#whereFrom").value = session.getItem("whereFrom");
        $w("#comment").value = session.getItem("comment");
    }
});

/**
 *	住所自動入力
 *	 @param {$w.Event} event
 */
export function postCode_blur(event) {
    if(event.target.value.indexOf("-") < 0 && event.target.value.length > 6){
        event.target.value = event.target.value.substr(0, 3) + "-" + event.target.value.substr(3, 4)
    }
	getAddress(event.target.value)
	.then(result =>{
		console.log(result);
		if(result.status == "200"){
			$w("#prefectures").value = result.results[0].address1;
			$w("#municipalities").value = result.results[0].address2 + result.results[0].address3;
			// $w("#address").value = result.results[0].address3;
		}
	});
}

/**
 *	入力情報確認ボタン
 *	 @param {$w.MouseEvent} event
 */
export function btnConfirm_click(event) {
	if (!$w("#firstName").valid) {
        $w("#firstName").focus();
        return;
    }
    if (!$w("#lastName").valid) {
        $w("#lastName").focus();
        return;
    }
    if (!$w("#firstNameKana").valid) {
        $w("#firstNameKana").focus();
        return;
    }
    if (!$w("#lastNameKana").valid) {
        $w("#lastNameKana").focus();
        return;
    }
    if (!$w("#email").valid) {
        $w("#email").focus();
        return;
    }
    if (!$w("#password").valid) {
        $w("#password").focus();
        return;
    }
    if (!$w("#country").valid) {
        $w("#country").focus();
        return;
    }
    if (!$w("#prefectures").valid) {
        $w("#prefectures").focus();
        return;
    }
    if (!$w("#municipalities").valid) {
        $w("#municipalities").focus();
        return;
    }
    if (!$w("#address").valid) {
        $w("#address").focus();
        return;
    }
    if (!$w("#phone").valid) {
        $w("#phone").focus();
        return;
    }
    if (!$w("#privacyPolicy").valid) {
        $w("#privacyPolicy").checked = false;
        return;
    }
   
    session.setItem("email", $w("#email").value);
    session.setItem("password", $w("#password").value);
    session.setItem("firstName", $w("#firstName").value);
    session.setItem("lastName", $w("#lastName").value);
    session.setItem("firstNameKana", $w("#firstNameKana").value);
    session.setItem("lastNameKana", $w("#lastNameKana").value);
    session.setItem("phone", $w("#phone").value);
    session.setItem("country", $w("#country").value);
    session.setItem("postCode", $w("#postCode").value);
    session.setItem("prefectures", $w("#prefectures").value);
    session.setItem("municipalities", $w("#municipalities").value);
    session.setItem("address", $w("#address").value);
    session.setItem("birthday", $w("#birthday").value ? $w("#birthday").value.toLocaleDateString() : "");
    session.setItem("sex", $w("#sex").value);
    session.setItem("whereFrom", $w("#whereFrom").value);
    session.setItem("comment", $w("#comment").value);
    wixLocation.to("/regconfirm");
}